import { render } from "./agregarCompania.vue?vue&type=template&id=15ffbae0&scoped=true"
import script from "./agregarCompania.vue?vue&type=script&lang=js"
export * from "./agregarCompania.vue?vue&type=script&lang=js"

import "./agregarCompania.vue?vue&type=style&index=0&id=15ffbae0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15ffbae0"]])

export default __exports__